import React from 'react';
import ModernHeader from '../components/ModernHeader';
import Footer from '../components/Footer';
import { useSettings } from '../context/SettingsContext';

const TermsOfService = () => {
  const { settings } = useSettings();
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)' }}>
      <ModernHeader tenant={{ name: 'Tiket Jini' }} />
      <div style={{ maxWidth: '800px', margin: '0 auto', background: 'white', borderRadius: '20px', padding: '40px', boxShadow: '0 10px 40px rgba(0,0,0,0.1)', marginTop: '40px', marginBottom: '40px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img src="/Logo1.png" alt="Tiket Jini" style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '20px' }} />
          <h1 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#2d3748', marginBottom: '10px' }}>Terms of Service</h1>
          <p style={{ color: '#64748b', fontSize: '1.1rem' }}>Last updated: December 2024</p>
        </div>

        <div style={{ lineHeight: '1.8', color: '#4a5568' }}>
          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>1. Acceptance of Terms</h2>
            <p>By accessing and using Tiket Jini's services, you accept and agree to be bound by the terms and provision of this agreement.</p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>2. Booking and Payment</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li>All bookings are subject to availability</li>
              <li>Payment must be completed at the time of booking</li>
              <li>Prices are subject to change without notice</li>
              <li>Additional charges may apply for special services</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>3. Ticket Validity</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Tickets are valid only for the date and time specified</li>
              <li>Entry is subject to venue capacity and operating hours</li>
              <li>Tickets are non-transferable and non-refundable unless specified</li>
              <li>Lost or damaged tickets cannot be replaced</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>4. User Responsibilities</h2>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Provide accurate information during booking</li>
              <li>Arrive on time for your scheduled visit</li>
              <li>Follow venue rules and regulations</li>
              <li>Respect other visitors and staff</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>5. Limitation of Liability</h2>
            <p>Tiket Jini shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services.</p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginBottom: '15px' }}>6. Contact Information</h2>
            <p>For questions about these Terms of Service, please contact us at:</p>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Email: {settings.supportEmail}</li>
              <li>Phone: {settings.supportPhone}</li>
            </ul>
          </section>
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '25px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            ← Back to Home
          </button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsOfService;